// extracted by mini-css-extract-plugin
module.exports = {"tbTagChainsMulti":"TagChains_tbTagChainsMulti__yfglN","tbTagChainsSingle":"TagChains_tbTagChainsSingle__FVUnk"};